export const purchaseOrderCsvColumnMapper = {
  projectName: '物件名',
  supplierName: '仕入先',
  orderNumber: '発注No',
  sourceFileName: '元PDF',
  lineNo: '行番号',
  steelType: '材質',
  sectionType: '形状',
  size: '寸法',
  length: '長さ',
  quantity: '本数',
  weight: '重量',
  orderedAt: '発注日',
  deliveryDueAt: '納期',
  deliveryPlace: '納入場所',
  plateNumber: '板番/製品番号',
  buildingPart: '部位',
  constructionArea: '工区',
  remarks: '備考',
} as const

// OCR と CSV の両経路で同じ業務検証を通すため、確認前の値は文字列・数値・空欄で受ける。
export type OrderImportRecord = Record<string, string | number | null>

export type OrderPdfMapping = {
  /** CSVの元PDF列と完全一致する原文ファイル名。 */
  sourceFileName: string
  s3ObjectId: string
}

export type OrderImportRowsInput = {
  tenantId: string
  /** 登録を承認したIdentity.id。Order.uploadedByIdとは参照先が異なる。 */
  uploadedById: string
  fileName: string
  records: OrderImportRecord[]
} & ({ source: 'csv'; pdfs: OrderPdfMapping[] } | { source: 'ai'; orderId: string })

export type OrderImportSummary = {
  totalRowCount: number
  createdOrderCount: number
  updatedOrderCount: number
  createdLineCount: number
  updatedLineCount: number
  deletedLineCount: number
  protectedLineCount: number
  registeredPdfCount: number
  errorRows: Array<{ rowNumber: number; message: string }>
}
